import React from 'react';
import { Navigate } from 'react-router-dom';
import { COMPANY_ARTIFACTS_SELECT_PATH } from '../../utils/companyArtifactRoutes';

/** `/artifacts` → canonical model-tree selection surface. */
const CompanyArtifactsIndex: React.FC = () => {
  return <Navigate to={COMPANY_ARTIFACTS_SELECT_PATH} replace />;
};

export default CompanyArtifactsIndex;
